"use client";

import { VolumeControl as ShadcnVolumeControl } from "./ui/volume-control";

type VolumeControlProps = {
  value: number;
  onChange: (value: number) => void;
};

export default function VolumeControl({ value, onChange }: VolumeControlProps) {
  return <ShadcnVolumeControl value={value} onChange={onChange} />;
}
